function AvatarBadge({
  avatar,
  name,
  size = "100%",
  borderColor = "var(--theme-background, #FFFFFF)",
}) {
  const initials = (name || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("") || "U";
  // The SVG viewBox is 142.059 × 105.53
  // Avatar circle center: 71.03, 52.77  radius: ~31.5
  const VW = 142.059;
  const VH = 105.53;
  const AX = 71.0297; // avatar center x
  const AY = 52.7656; // avatar center y
  const AR = 31.5048; // avatar clip radius

  const uid = name.replace(/\s+/g, "-").toLowerCase();
  const clipId = `avatarClip-${uid}`;
  const gradId1 = `grad1-${uid}`;
  const filterId = `shadow-${uid}`;
  const radGradId = `radgrad-${uid}`;
  // Scale the border path from seal center to make the pseudo-border thicker
  const sealCenterX = 71.03;
  const sealCenterY = 52.77;
  const borderScale = 1.04;
  const borderTransform = `translate(${sealCenterX} ${sealCenterY}) scale(${borderScale}) translate(${-sealCenterX} ${-sealCenterY})`;

  return (
    <svg
      width={size}
      viewBox={`0 0 ${VW} ${VH}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
      aria-label={name}
      role="img"
    >
      <defs>
        {/* Avatar clip — same circle as the original clip1 */}
        <clipPath id={clipId}>
          <circle cx={AX} cy={AY} r={AR} />
        </clipPath>

        {/* Reuse gradients from original SVG, scoped per instance */}
        <radialGradient
          id={radGradId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform={`translate(${AX} ${AY}) rotate(90) scale(52.7649 87.7148)`}
        >
          <stop stopColor="#717784" />
          <stop offset="1" stopColor="#717784" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id={gradId1}
          x1={AX}
          y1="20.2949"
          x2={AX}
          y2="85.2363"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#335CFF" />
          <stop offset="1" stopColor="#122368" stopOpacity="0" />
        </linearGradient>
        <filter
          id={filterId}
          x="12.5667"
          y="-3.00209"
          width="117.926"
          height="117.926"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.02941" />
          <feGaussianBlur stdDeviation="5.07353" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.231373 0 0 0 0 0.678431 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>

      {/* ── Ribbon left arrow ── */}
      <path
        d="M34.4666 39.2363C35.2323 39.2363 35.8531 39.7748 35.8531 40.4389V59.6808C35.8531 60.345 35.2323 60.8835 34.4666 60.8835L-0.640288 60.8835C-1.82205 60.8835 -2.46206 59.6832 -1.69678 58.9021L6.20313 50.8387C6.64308 50.3896 6.64308 49.7302 6.20313 49.2811L-1.69678 41.2177C-2.46205 40.4366 -1.82205 39.2363 -0.64029 39.2363L34.4666 39.2363Z"
        fill="#1F3BAD"
      />

      {/* ── Ribbon right arrow ── */}
      <path
        d="M107.593 39.2363C106.827 39.2363 106.206 39.7748 106.206 40.4389V59.6808C106.206 60.345 106.827 60.8835 107.593 60.8835L142.7 60.8835C143.881 60.8835 144.521 59.6832 143.756 58.9021L135.856 50.8387C135.416 50.3896 135.416 49.7302 135.856 49.2811L143.756 41.2177C144.521 40.4366 143.881 39.2363 142.7 39.2363L107.593 39.2363Z"
        fill="#1F3BAD"
      />

      {/* ── Toothed seal ── */}
      {/* Outer border ring — no filter, to avoid blue drop shadow on the border */}
      <path
        fill={borderColor}
        transform={borderTransform}
        d="M68.0139 8.09277C69.626 6.30282 72.4329 6.30284 74.0451 8.09277L75.7726 10.0098C76.2179 10.5041 76.9568 10.6015 77.5148 10.2393L79.6789 8.83398C81.6994 7.52236 84.4111 8.2493 85.5051 10.3955L86.6769 12.6943C86.9791 13.287 87.6672 13.5717 88.3 13.3662L90.7541 12.5693C93.0453 11.8253 95.4765 13.2297 95.9777 15.5859L96.5148 18.1094C96.6533 18.7602 97.2449 19.2134 97.9094 19.1787L100.486 19.0439C102.891 18.9182 104.877 20.9039 104.751 23.3096L104.616 25.8867C104.582 26.551 105.035 27.1418 105.686 27.2803L108.21 27.8174C110.566 28.3187 111.97 30.7499 111.226 33.041L110.429 35.4951C110.223 36.1278 110.508 36.8159 111.101 37.1182L113.401 38.29C115.547 39.384 116.273 42.0957 114.961 44.1162L113.556 46.2812C113.194 46.8391 113.291 47.5773 113.785 48.0225V48.0234L115.703 49.75C117.493 51.3621 117.493 54.1691 115.703 55.7812L113.785 57.5088C113.291 57.9541 113.194 58.693 113.556 59.251L114.961 61.415C116.273 63.4355 115.547 66.1471 113.401 67.2412L111.101 68.4131C110.508 68.7153 110.224 69.4035 110.429 70.0361L111.226 72.4902C111.97 74.7813 110.566 77.2125 108.21 77.7139L105.686 78.251C105.035 78.3895 104.582 78.9811 104.616 79.6455L104.751 82.2217C104.877 84.6274 102.891 86.613 100.486 86.4873L97.9094 86.3525C97.245 86.3178 96.6533 86.7712 96.5148 87.4219L95.9777 89.9463C95.4764 92.3024 93.0452 93.7059 90.7541 92.9619L88.3 92.165C87.6673 91.9597 86.9792 92.2444 86.6769 92.8369L85.5051 95.1367C84.411 97.2827 81.6993 98.0089 79.6789 96.6973L77.5148 95.292C76.9569 94.9298 76.2179 95.0273 75.7726 95.5215L74.0451 97.4395C72.4329 99.229 69.626 99.2291 68.0139 97.4395L66.2873 95.5215H66.2863C65.8411 95.0276 65.103 94.9301 64.5451 95.292L62.3801 96.6973C60.3596 98.0088 57.6479 97.2828 56.5539 95.1367L55.382 92.8369C55.0797 92.2445 54.3916 91.9596 53.759 92.165L51.3049 92.9619C49.0137 93.706 46.5826 92.3024 46.0812 89.9463L45.5441 87.4219C45.4056 86.7713 44.8148 86.318 44.1506 86.3525L41.5734 86.4873C39.1677 86.613 37.1821 84.6274 37.3078 82.2217L37.4426 79.6455C37.4773 78.9811 37.024 78.3894 36.3732 78.251L33.8498 77.7139C31.4935 77.2126 30.0891 74.7814 30.8332 72.4902L31.6301 70.0361C31.8355 69.4034 31.5509 68.7152 30.9582 68.4131L28.6594 67.2412C26.5132 66.1472 25.7862 63.4356 27.0978 61.415L28.5031 59.251C28.8654 58.6929 28.768 57.9541 28.2736 57.5088L26.3566 55.7812C24.5667 54.169 24.5667 51.3622 26.3566 49.75L28.2736 48.0234V48.0225C28.7678 47.5772 28.8652 46.8392 28.5031 46.2812L27.0978 44.1162C25.7864 42.0957 26.5132 39.384 28.6594 38.29L30.9582 37.1182C31.5508 36.816 31.8355 36.1279 31.6301 35.4951L30.8332 33.041C30.0892 30.7498 31.4935 28.3186 33.8498 27.8174L36.3732 27.2803C37.0239 27.1419 37.4772 26.5511 37.4426 25.8867L37.3078 23.3096C37.1821 20.9039 39.1677 18.9182 41.5734 19.0439L44.1506 19.1787C44.8149 19.2133 45.4057 18.7601 45.5441 18.1094L46.0812 15.5859C46.5825 13.2297 49.0137 11.8253 51.3049 12.5693L53.759 13.3662C54.3917 13.5717 55.0798 13.287 55.382 12.6943L56.5539 10.3955C57.6478 8.24938 60.3596 7.52256 62.3801 8.83398L64.5451 10.2393C65.1031 10.6013 65.8411 10.5039 66.2863 10.0098H66.2873L68.0139 8.09277Z"
      />

      {/* ── Main blue toothed seal disc — drop shadow applied here only ── */}
      <g filter={`url(#${filterId})`}>
        <path
          fill="#1F3BAD"
          d="M69.0191 8.99791C70.0939 7.8046 71.9654 7.8046 73.0402 8.99791L74.7672 10.9153C75.6577 11.9041 77.135 12.0985 78.2512 11.374L80.4155 9.96889C81.7626 9.09441 83.5704 9.57881 84.2997 11.0096L85.4715 13.3087C86.0758 14.4942 87.4525 15.0644 88.7181 14.6534L91.1724 13.8564C92.6998 13.3604 94.3207 14.2962 94.6548 15.867L95.1917 18.391C95.4686 19.6925 96.6507 20.5996 97.9796 20.5302L100.557 20.3955C102.16 20.3117 103.484 21.6351 103.4 23.2389L103.265 25.8159C103.196 27.1447 104.103 28.3269 105.404 28.6037L107.928 29.1406C109.499 29.4748 110.435 31.0956 109.939 32.6231L109.142 35.0773C108.731 36.343 109.301 37.7196 110.487 38.3239L112.786 39.4958C114.217 40.2251 114.701 42.0329 113.827 43.3799L112.421 45.5443C111.697 46.6604 111.891 48.1377 112.88 49.0282L114.798 50.7552C115.991 51.83 115.991 53.7016 114.798 54.7764L112.88 56.5033C111.891 57.3939 111.697 58.8712 112.421 59.9873L113.827 62.1517C114.701 63.4987 114.217 65.3065 112.786 66.0358L110.487 67.2077C109.301 67.812 108.731 69.1886 109.142 70.4542L109.939 72.9085C110.435 74.436 109.499 76.0568 107.928 76.3909L105.404 76.9278C104.103 77.2047 103.196 78.3868 103.265 79.7157L103.4 82.2926C103.484 83.8964 102.16 85.2199 100.557 85.136L97.9796 85.0014C96.6507 84.932 95.4686 85.839 95.1917 87.1406L94.6548 89.6646C94.3207 91.2354 92.6998 92.1712 91.1724 91.6752L88.7181 90.8782C87.4525 90.4671 86.0758 91.0374 85.4715 92.2229L84.2997 94.5219C83.5704 95.9528 81.7626 96.4372 80.4155 95.5627L78.2512 94.1576C77.135 93.433 75.6577 93.6275 74.7672 94.6163L73.0402 96.5337C71.9654 97.727 70.0939 97.727 69.0191 96.5337L67.2921 94.6163C66.4015 93.6275 64.9243 93.433 63.8081 94.1576L61.6438 95.5627C60.2967 96.4372 58.4889 95.9528 57.7596 94.5219L56.5877 92.2229C55.9834 91.0374 54.6068 90.4671 53.3412 90.8782L50.8869 91.6752C49.3595 92.1712 47.7386 91.2354 47.4045 89.6646L46.8676 87.1406C46.5907 85.839 45.4086 84.932 44.0797 85.0014L41.5028 85.136C39.899 85.2199 38.5756 83.8964 38.6594 82.2926L38.794 79.7157C38.8635 78.3868 37.9564 77.2047 36.6548 76.9278L34.1308 76.3909C32.56 76.0568 31.6242 74.436 32.1203 72.9085L32.9173 70.4542C33.3283 69.1886 32.7581 67.812 31.5725 67.2077L29.2735 66.0358C27.8427 65.3065 27.3583 63.4987 28.2327 62.1517L29.6378 59.9873C30.3624 58.8712 30.1679 57.3939 29.1791 56.5033L27.2618 54.7764C26.0685 53.7016 26.0685 51.83 27.2618 50.7552L29.1791 49.0282C30.1679 48.1377 30.3624 46.6604 29.6378 45.5443L28.2327 43.3799C27.3583 42.0329 27.8427 40.2251 29.2735 39.4958L31.5725 38.3239C32.7581 37.7196 33.3283 36.343 32.9173 35.0773L32.1203 32.6231C31.6242 31.0956 32.56 29.4748 34.1308 29.1406L36.6548 28.6037C37.9564 28.3269 38.8635 27.1447 38.794 25.8159L38.6594 23.2389C38.5756 21.6351 39.899 20.3117 41.5028 20.3955L44.0797 20.5302C45.4086 20.5996 46.5907 19.6925 46.8676 18.391L47.4045 15.867C47.7386 14.2962 49.3595 13.3604 50.8869 13.8564L53.3412 14.6534C54.6068 15.0644 55.9834 14.4942 56.5877 13.3087L57.7596 11.0096C58.4889 9.57881 60.2967 9.09441 61.6438 9.96889L63.8081 11.374C64.9243 12.0985 66.4015 11.9041 67.2921 10.9153L69.0191 8.99791Z"
        />
      </g>

      {/* ── Lavender ring ── */}
      <circle cx={AX} cy={AY} r={AR + 1} fill="#CAC0FF" />

      {/* ── Avatar circle (image or fallback) ── */}
      <clipPath id={clipId}>
        <circle cx={AX} cy={AY} r={AR} />
      </clipPath>

      {avatar ? (
        <image
          href={avatar}
          x={AX - AR}
          y={AY - AR}
          width={AR * 2}
          height={AR * 2}
          clipPath={`url(#${clipId})`}
          preserveAspectRatio="xMidYMid slice"
        />
      ) : (
        <g clipPath={`url(#${clipId})`}>
          <circle cx={AX} cy={AY} r={AR} fill="#CAC0FF" />
          <text
            x={AX}
            y={AY + 6}
            textAnchor="middle"
            fill="#FFFFFF"
            fontSize="28"
            fontWeight="700"
            style={{ textTransform: "uppercase" }}
          >
            {initials}
          </text>
        </g>
      )}

      {/* ── Subtle inner halo on the avatar disc ── */}
      <circle
        cx={AX}
        cy={AY}
        r={AR}
        fill="none"
        stroke={`url(#${gradId1})`}
        strokeOpacity="0.16"
        strokeWidth="2.70589"
        style={{ mixBlendMode: "color-dodge" }}
      />
    </svg>
  );
}

export default AvatarBadge;
